import { render, staticRenderFns } from "./MessageTemplateTab.vue?vue&type=template&id=352f60e9&scoped=true&"
import script from "./MessageTemplateTab.vue?vue&type=script&lang=js&"
export * from "./MessageTemplateTab.vue?vue&type=script&lang=js&"
import style0 from "./MessageTemplateTab.vue?vue&type=style&index=0&id=352f60e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352f60e9",
  null
  
)

export default component.exports